import type { SpotResultsInfoBoxAttributes } from '@/features/spot-results/spot-results-v4/spot-results-v4-type';

import React from 'react';

import { HtmlTextWrapper, Link } from '@/core/features';
import { useResetMap } from '@/features/map/map-data-v5/use-map-data-v5';

export default function SpotResultsInfoBoxDesktop({
    ctaText,
    htmlText,
    linkUrl,
    secondaryCtaText,
    secondaryLinkUrl,
    title,
}: SpotResultsInfoBoxAttributes) {
    const resetMap = useResetMap();

    return (
        <div className={'flex-column margin-top-5 gap-20 bg-white'}>
            <div className={'line-height-14 font-size-18 bold'}>{title}</div>
            <div className={'font-size-16'}>
                <HtmlTextWrapper htmlText={htmlText} />
            </div>
            <div className={'flex-column gap-15'}>
                <Link
                    className={'width-fit-content'}
                    href={linkUrl}
                    linkType={'internal'}
                    onClick={resetMap}
                >
                    <button
                        className={
                            'border border-endeavour border-radius-30 padding-left-20 padding-right-20 text-endeavour pointer'
                        }
                        style={{
                            // eslint-disable-next-line no-inline-styles/no-inline-styles
                            height: '36px',
                        }}
                    >
                        {ctaText}
                    </button>
                </Link>
                {secondaryLinkUrl && secondaryCtaText && (
                    <Link
                        className={'width-fit-content'}
                        href={secondaryLinkUrl}
                        linkType={'internal'}
                        onClick={resetMap}
                    >
                        <button
                            className={
                                'border border-endeavour border-radius-30 padding-left-20 padding-right-20 text-endeavour pointer'
                            }
                            style={{
                                // eslint-disable-next-line no-inline-styles/no-inline-styles
                                height: '36px',
                            }}
                        >
                            {secondaryCtaText}
                        </button>
                    </Link>
                )}
            </div>
        </div>
    );
}
